import type { RoseRocketOrder, SheetRow } from '../types/entities';
import { formatAddress, withSyncFields } from './helpers';

export async function mapOrder(order: RoseRocketOrder): Promise<SheetRow> {
  return withSyncFields({
    rr_order_id: order.id,
    order_number: order.order_number,
    status: order.status,
    customer_id: order.customer_id || '',
    customer_name: order.customer_name,
    pickup_name: order.pickup_location?.name || '',
    pickup_address: formatAddress(order.pickup_location),
    pickup_city: order.pickup_location?.city || '',
    pickup_state: order.pickup_location?.state || '',
    pickup_postal_code: order.pickup_location?.postal_code || '',
    delivery_name: order.delivery_location?.name || '',
    delivery_address: formatAddress(order.delivery_location),
    delivery_city: order.delivery_location?.city || '',
    delivery_state: order.delivery_location?.state || '',
    delivery_postal_code: order.delivery_location?.postal_code || '',
    pickup_date: order.pickup_date || '',
    delivery_date: order.delivery_date || '',
    carrier_name: order.carrier_name || '',
    driver_name: order.driver_name || '',
    equipment_type: order.equipment_type || '',
    reference_number: order.reference_number || '',
    rate: order.rate ?? '',
    currency: order.currency || '',
    rr_created_at: order.created_at || '',
    rr_updated_at: order.updated_at,
  });
}
